// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import MoveUpSvg from '@rsuite/icon-font/lib/action/MoveUp';
var MoveUp = createSvgIcon({
  as: MoveUpSvg,
  ariaLabel: 'move up',
  category: 'action',
  displayName: 'MoveUp'
});
export default MoveUp;